import React from "react";

export const LOGO_URL = "/media/jt-logo.png";
const LOGO_CLEAR = "/media/jt-logo-transparent.png";

// Transparent logo in light mode; white surface in dark mode so the dark lettering stays readable.
export const Logo = ({ height = 40, className = "", rounded = "rounded-lg" }) => {
  return (
    <span className={`inline-flex items-center justify-center ${rounded} px-2 py-1 dark:bg-white ${className}`} data-testid="site-logo">
      <img src={LOGO_CLEAR} alt="The JT Hub" style={{ height }} className="w-auto object-contain dark:hidden" draggable={false} />
      <img src={LOGO_URL} alt="The JT Hub" style={{ height }} className="hidden w-auto object-contain dark:block" draggable={false} />
    </span>
  );
};

export default Logo;
